var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerspectiveShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.141 4.16282L18.141 5.87682C18.3794 5.91077 18.5975 6.0296 18.7553 6.21147C18.9131 6.39334 19 6.62604 19 6.86682V17.1328C19 17.3736 18.9131 17.6063 18.7553 17.7882C18.5975 17.97 18.3794 18.0889 18.141 18.1228L6.141 19.8368C5.9992 19.857 5.85471 19.8465 5.71731 19.806C5.57992 19.7655 5.45283 19.696 5.34464 19.6021C5.23645 19.5083 5.14969 19.3922 5.09023 19.2619C5.03077 19.1316 5 18.9901 5 18.8468V5.15282C5 5.00959 5.03077 4.86802 5.09023 4.73771C5.14969 4.6074 5.23645 4.49138 5.34464 4.39751C5.45283 4.30364 5.57992 4.23411 5.71731 4.19362C5.85471 4.15313 5.9992 4.14263 6.141 4.16282Z",
    fill: "#FDA6D6",
    stroke: "#FDA6D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerspectiveShape);
export default __webpack_public_path__ + "static/media/perspective-shape.0f61946c0f33e16b0ef86dfff77a98f4.svg";
export { ForwardRef as ReactComponent };